import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { OBJECT_TYPE_SQL_QUERY } from '../../graphql.js'
import { Alert } from 'reactstrap'
import Spinner from '../Spinner/Spinner.js'
import { getData } from '../CustomCode/CustomUtils'

const OBJECT_TYPE_SQL = gql(OBJECT_TYPE_SQL_QUERY)

export default function ObjectTypeSQL({ location }) {
  console.log('ObjectTypeSQL rendered: ', location)

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])
  const params = new URLSearchParams(location.search)
  const objectTypeId = params.get('objectTypeId')

  useEffect(() => {
    getData(null, OBJECT_TYPE_SQL, 'objectTypeSQL', setResults, setGraphQLErrors, 'objectTypeId', objectTypeId)
  }, [objectTypeId])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    return (
      <div style={{ height: '100%', overflow: 'auto',  padding: '10px' }}>
        <div dangerouslySetInnerHTML={{ __html: results }} />
      </div>
    )
  }
}
